import { Component, Inject, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';
import { ProductEvaluationTaskService } from '../../../services/product-evaluation-task.service';
import { ProductsForTaskDetails } from '../../../models/product-evaluation-tasks/ProductsForTaskDetails';
import { ProductEvaluationTasksSurveyComponent } from '../product-evaluation-tasks-survey/product-evaluation-tasks-survey.component';
import { ProductEvaluateStatusEnum } from '../../../models/product-evaluation-tasks/enums/ProductEvaluateStatusEnum';

@Component({
  selector: 'app-products-evaluation-task',
  standalone: false,
  templateUrl: './products-evaluation-task.component.html',
})
export class ProductsEvaluationTaskComponent implements OnInit, OnDestroy {
  @Input({ required: true }) taskId: number;
  dataLoading = true;
  pageCount = 0;
  imagePreview: any;
  recordsData: ProductsForTaskDetails = new ProductsForTaskDetails();
  refreshSub: Subscription[] = [];
  subscriptions: Subscription[] = [];
  selectedRecordId: any;
  productEvaluateStatus = ProductEvaluateStatusEnum

  constructor(
    public dialog: MatDialog,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private service: ProductEvaluationTaskService,
  ) { }

  ngOnInit() {
    this.getAll();

    this.refreshSub.push(
      this.service.refreshProducts.subscribe(data => {
        if (data) {
          this.getAll();
        }
      })
    )
  }

  getAll() {
    this.dataLoading = true;
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions.push(
      this.service.getProductToCheckForTaskDetails(this.taskId).subscribe(
        (data: any) => {
          this.dataLoading = false;
          if (data) {
            this.recordsData = data;
          }
        },
        (error: any) => {
          this.recordsData = new ProductsForTaskDetails();
          this.dataLoading = false;
        })
    )
  }

  openForm(productId: number) {
    const dialogRef = this.dialog.open(ProductEvaluationTasksSurveyComponent, {
      width: '1200px',
      maxWidth: '1200px',
      data: {
        taskId: this.taskId,
        productId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAll();
        this.service.refreshDetails.next(true);
      }
    });
  }

  filePreview(monitorTaskProductId: number) {

    // this.service.getetMonitorTaskProductAttachments(monitorTaskProductId).subscribe(
    //   (data: any) => {
    //     if (data) {
    //       this.imagePreview = data[0].path
    //       this.renderer.addClass(document.body, 'overflow-hidden');
    //     }
    //   }
    // ), error => {

    // }
  }

  closePreview() {
    this.imagePreview = '';
    this.renderer.removeClass(document.body, 'overflow-hidden');
  }

  ngOnDestroy() {
    this.service.refreshProducts.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.refreshSub.forEach(sub => sub.unsubscribe());
  }
}
